import {
  InstagramCircle,
  LinkedInCircle,
  TwitterCircle,
  YouTubeCircle,
} from 'modules/ui/logo';
import { StyledSocialLink, StyledSocialLinksList } from './styled';

// className needed for using this component as a styled component
export const SocialLinks: React.FC<{ className?: string }> = ({
  className,
}) => (
  <StyledSocialLinksList className={className}>
    <li>
      <StyledSocialLink
        to={{ pathname: 'https://twitter.com/zabaINFO' }}
        target="_blank">
        <TwitterCircle />
      </StyledSocialLink>
    </li>
    <li>
      <StyledSocialLink
        to={{ pathname: 'https://www.linkedin.com/company/zagrebacka-banka' }}
        target="_blank">
        <LinkedInCircle />
      </StyledSocialLink>
    </li>
    <li>
      <StyledSocialLink
        to={{
          pathname: 'https://www.youtube.com/channel/UCPO1SAxHj8_K5vLk_zyJSHw',
        }}
        target="_blank">
        <YouTubeCircle />
      </StyledSocialLink>
    </li>
    <li>
      <StyledSocialLink to={{ pathname: '' }}>
        <InstagramCircle />
      </StyledSocialLink>
    </li>
  </StyledSocialLinksList>
);
